<template>
  <div>
    <div class="author container" v-if="recipes && recipes.length > 0">
      <Title markup="h1" v-if="display">{{ recipes[0].author.name }}</Title>
    </div>
    <RecipeGrid v-if="recipes" :recipes="recipes" />
  </div>
</template>
<script>
import Title from "@/components/ui/Title.vue";
import RecipeGrid from "@/components/listing/RecipeGrid.vue";

export default {
  name: "Recipes",
  components: {
    RecipeGrid,
    Title
  },
  data() {
    return {
      display: false,
      recipes: false
    };
  },
  mounted() {
    this.fetchRecipes();
  },
  methods: {
    async fetchRecipes() {
      // TAKE RECIPE IN STORE
      if (this.$store.state.recipes.length >= 1) {
        this.recipes = this.$store.state.recipes.filter(recipe => {
          return recipe.author.slug == this.$route.params.slug;
        });
      } else {
        this.recipes = await this.getApi(
          "recipes/?author=" + this.$route.params.slug
        );
      }
    }
  }
};
</script>
